import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	manageIssueTypes: {
		id: 'config-in-context-issue-types.common.manage-issue-types',
		defaultMessage: 'Manage issue types',
		description:
			'Dropdown menu item. Clicking this will take the user to a page where they can manage the the project issue types.',
	},
});
